import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function ProductSection() {
  const { t } = useLang();
  const p = t.product;

  return (
    <section id="product" className="py-24 bg-misky-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '80px 80px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="mb-16">
          <p className="text-misky-mid text-xs uppercase mb-2">{p.sectionLabel}</p>
          <h2 className="text-4xl sm:text-5xl font-bold">{p.title}</h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Label visual */}
          <div className="bg-white/5 border border-white/10 rounded-3xl p-8 flex flex-col items-center gap-5">
            <div className="text-center">
              <div className="font-display text-5xl font-bold tracking-widest text-white">MISKY</div>
              <div className="text-misky-light text-sm tracking-[0.3em] uppercase">Ceramide Complex 2%</div>
            </div>

            <div className="relative w-40 h-28">
              <div className="absolute inset-0 bg-gradient-to-b from-gray-100 to-gray-300 shadow-2xl"
                style={{ borderRadius: '60% 40% 55% 45% / 45% 45% 55% 55%' }} />
              <div className="absolute top-3 left-4 right-8 h-3 bg-white/50 rounded-full blur-sm" />
            </div>

            <div className="text-3xl font-bold text-white">مسكي</div>

            <div className="border-t border-white/10 pt-4 w-full text-center">
              <div className="font-display text-lg font-semibold tracking-wider">{p.faceBody}</div>
              <div className="text-misky-mid text-sm tracking-widest uppercase">{p.dailySkin}</div>
            </div>

            <div className="flex flex-wrap justify-center gap-3 text-xs text-misky-mid">
              <span>🍃 {t.hero.badges[0]}</span>
              <span>•</span>
              <span>🛡️ {t.hero.badges[1]}</span>
              <span>•</span>
              <span>💧 {t.hero.badges[2]}</span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl px-4 py-2 text-center text-sm text-misky-light">
              {p.externalOnly}
            </div>
          </div>

          {/* How to use */}
          <div>
            <h3 className="text-2xl font-bold mb-8">{p.howToUse}</h3>

            <div className="space-y-4">
              {p.steps.map((step, i) => (
                <div key={i} className="flex gap-4 p-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                  <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0 text-lg">
                    {step.icon}
                  </div>
                  <p className="text-sm text-misky-light self-center leading-relaxed">{step.text}</p>
                </div>
              ))}
            </div>

            {/* Warnings */}
            <div className="mt-8 p-5 rounded-2xl border border-white/10 bg-white/5">
              <div className="text-xs tracking-widest uppercase text-misky-mid mb-3">{p.warningsLabel}</div>
              <ul className="space-y-1.5">
                {p.warnings.map((w, i) => (
                  <li key={i} className="text-xs text-misky-light flex items-start gap-2">
                    <span className="text-misky-mid mt-0.5 flex-shrink-0">—</span>
                    {w}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
